module.exports = __webpack_public_path__ + "static/media/winter_2.240bd402.jpg";